import { COMPANY_ADMIN_ROLE } from 'constants/companyRoles';

// Same bounds as the api (useCases/company/companyMemberInput.js), which
// re-checks the edit screen and the add modal alike and is the judge on both:
// a check here saves a round trip, and goes further than the api for addresses
// login would refuse (see EMAIL_PATTERN).
export const NAME_MAX_LENGTH = 35;
// Accepts what both login's sign-in check and the api's isEmail accept, so no
// account is created that cannot sign in or be edited. Plus addresses and long
// extensions pass (helper.js's EMAIL_REGEX refuses them); accents and
// apostrophes in the local part do not, because login refuses them.
const EMAIL_PATTERN =
  /^[\w+-]+(\.[\w+-]+)*@([a-zA-Z\d]([a-zA-Z\d-]*[a-zA-Z\d])?\.)+[a-zA-Z]{2,}$/;

export const isValidContactEmail = (email) =>
  EMAIL_PATTERN.test((email ?? '').trim());

// No character whitelist on purpose: names such as Hélène or O’Neil are
// valid, and the api only bounds the trimmed length too.
export const isValidContactName = (value) => {
  const length = (value ?? '').trim().length;
  return length >= 1 && length <= NAME_MAX_LENGTH;
};

// Returns { field: messageKey }, keys under companyContacts.edit.errors.
export const validateContactForm = (
  form,
  { otherAdminExists = false } = {},
) => {
  const errors = {};
  ['firstName', 'lastName'].forEach((field) => {
    const value = (form[field] ?? '').trim();
    if (!value) errors[field] = 'required';
    else if (value.length > NAME_MAX_LENGTH) errors[field] = 'nameTooLong';
  });
  const email = (form.email ?? '').trim();
  if (!email) errors.email = 'required';
  else if (!isValidContactEmail(email)) errors.email = 'emailInvalid';
  if (!form.role) errors.role = 'required';
  else if (Number(form.role) === COMPANY_ADMIN_ROLE && otherAdminExists)
    errors.role = 'adminTaken';
  return errors;
};
